import React, { useState, useRef, useEffect } from "react";
import { getUserToken } from "../../helpers/authHelper";
import { toast } from "react-toastify";
import { createtag } from "../../services/pendingService";
import plus_icon from "../../assets/images/icon/plus.svg";
const SearchData = ({ applId, getPendingList, tags }) => {
  const [teams, setTeams] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const containerRef = useRef(null);
  const inputRef = useRef(null);
  const [newTag, setNewTag] = useState("");

  const searchTags = searchTerm
    .split(",")
    .map(tag => tag.trim().toLowerCase())
    .filter(tag => tag);

  const filteredTeams = teams.filter(team =>
    searchTags.every(tag => team.tags.some(t => t.toLowerCase().includes(tag)))
  );

  const handleTeamSelect = team => {
    setSelectedTags(prevTags => [...new Set([...prevTags, ...team.tags])]);
    setShowDropdown(false);
  };

  const handleTagRemove = tagToRemove => {
    setSelectedTags(prevTags => prevTags.filter(tag => tag !== tagToRemove));
  };

  useEffect(() => {
    // console.log(tags)
    setTeams(tags.map(tag => ({ name: tag.label, tags: [tag.label] })));
    // getSuggestedTags();
    const handleClickOutside = event => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
        handleSubmitTag();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectedTags]);

  const handleInputClick = () => {
    setShowDropdown(true);
  };

  const handleSubmitTag = async () => {
    const tagValue = [...selectedTags].join(",");
    if (!tagValue || tagValue.trim() === "") {
      const inputValue = inputRef.current.value;
      if (inputValue && inputValue.trim() !== "") {
        handleSubmit(applId, inputValue);
      }
      return;
    }
    handleSubmit(applId, tagValue);
    setSearchTerm(""); // Clear the search term
    setNewTag(""); // Clear the new tag value
    setSelectedTags([]); // Clear the selected tags
    inputRef.current.value = ""; // Clear the input field value
  };

  const handleSubmit = async (applId, tagValue) => {
    if (!tagValue || tagValue.trim() === "") {
      toast.error("Please enter a valid tag");
      return;
    }
    console.log(`Tag submitted for appl_id ${applId}: ${tagValue}`);
    createtag(applId, tagValue).then(res => {
      if (res.status === 200) {
        toast.success("Tag Added successfully.");
        getPendingList();
      } else {
        toast.error(res?.data?.message);
      }
    });
  };

  const handleInputChange = e => {
    const inputValue = e.target.value;
    setSearchTerm(inputValue);
    if (!filteredTeams.length && inputValue.trim() !== "") {
      setNewTag(inputValue);
    }
  };

  const handleKeyDown = e => {
    if (e.key === "Enter") {
      e.preventDefault();
      if (newTag && newTag.trim() !== "") {
        setSelectedTags([...selectedTags, newTag]);
        setNewTag("");
        setSearchTerm("");
      }
    }
  };

  const handleCreateNewTag = () => {
    setSelectedTags([...selectedTags, newTag]);
    setNewTag("");
  };

  return (
    <div className="seachData-section" ref={containerRef}>
      <input
        type="text"
        placeholder="Enter tags..."
        value={searchTerm}
        onChange={handleInputChange}
        onClick={handleInputClick}
        onKeyDown={handleKeyDown}
        ref={inputRef}
        className="form-control"
        title={`Please enter tags`}
      />
      {showDropdown && searchTerm && (
        <ul>
          {filteredTeams.length > 0 ? (
            filteredTeams.map((team, index) => (
              <li key={index} onClick={() => handleTeamSelect(team)}>
                <span>{team.name}</span>
              </li>
            ))
          ) : (
            <li>
              <span>
                <button
                  key={newTag}
                  onClick={handleCreateNewTag}
                  className="create-tag-button"
                >
                  Create "{newTag}"
                </button>
              </span>
            </li>
          )}
        </ul>
      )}
      <div className="selected-data-card length-selected-data">
        {selectedTags.length > 0}
        {selectedTags.length > 0 ? (
          selectedTags.map((tag, index) => (
            <div className="select-para" key={index}>
              <p>
                <span className="selected-tag">{tag}</span>
                <button
                  className="remove-tag-button"
                  onClick={() => handleTagRemove(tag)}
                >
                  &times;
                </button>
              </p>
            </div>
          ))
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default SearchData;
